export default __webpack_public_path__ + "static/media/project-img-4.b10652b2.png";